module.exports = __webpack_public_path__ + "src/assets/img/box.2eff3fda.png";